




import { Component, Vue } from 'vue-property-decorator';

@Component({ components: {} })
export default class Logout extends Vue {
    constructor() {
        super();
        this.$store.dispatch('logoutUser');
    }
}
